<template>
  <b-container class="container">
    <b-collapse v-model="btn_toggle">
      <b-button @click="new_sponsor" variant="success">Add Sponsor</b-button>
    </b-collapse>
    <b-collapse v-model="additem_toggle">
      <b-row class="mt-1">
        <b-col>
          <label>Sponsor's Name</label>
          <b-form-input v-model="item.name"></b-form-input>
          <b-collapse v-model="name_error">
              <label class="error">A name has to be provided</label>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <label>Sponsor URL</label>
          <b-form-input v-model="item.url"></b-form-input>
          <b-collapse v-model="url_error">
              <label class="error">URL has to be provided</label>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Sponsor Logo</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col  style="position:relative;line-height:0.7rem;">
       <b-button-group>
         <b-button class="mb-1" 
           :variant="item.event_sponsor ? 'outline-secondary':'vxon'"
           @click="SetStatus(false)">
           Session Only
         </b-button>
         <b-button class="mb-1" 
           :variant="item.event_sponsor ? 'vxon':'outline-secondary'"
           @click="SetStatus(true)">
           Event and Session
         </b-button>
       </b-button-group>
         <div v-if="item.event_sponsor" style="font-size:0.7rem;">
           This sponsor is for the event and selected sessions
         </div>
          <div v-if="!item.event_sponsor" style="font-size:0.7rem;">
           This sponsor is only for selected sessions
         </div>
    </b-col>
      </b-row>
      <b-row>
        <b-col>
          <upload-image
            v-model="item.logo"
            :evid="$parent.event.id"
            :imgkind="'sponsor'+item.id+'-pic'"
          />
        </b-col>
      </b-row>
      <br>
      <b-button v-bind:disabled="isSubmitDisabled" v-on:click="updateitem" variant="success">Submit</b-button>
      <b-button v-on:click="hide_form" variant="success">Cancel</b-button>
      <!-- eslint-disable-next-line vue/no-parsing-error -->
      </b-col>
      <!-- eslint-disable-next-line vue/no-parsing-error -->
      </b-row>
    </b-collapse>
    <b-collapse v-model="itemdeck">
      <b-card-group deck>
        <!-- eslint-disable-next-line vue/valid-v-for -->
        <b-card v-for="(sponsor,index) in $parent.event.sponsors"
            title="" class="event_card">
          <img fluid :src="sponsor.logo" @click="openimg(sponsor.url)" class="sponsoricon"/>&nbsp; &nbsp;
          <div />
          <b>{{ sponsor.name }}</b>&nbsp;<br><br>
          <b-button variant="primary" size="sm" @click="edititem(index)">
            Edit
          </b-button>
          <confirm-del variant="danger"
            v-on:confirmed-delete="deleteitem(index)">
          </confirm-del>
        </b-card>
      </b-card-group>
    </b-collapse>
  </b-container>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import UploadImage from "../components/UploadImage";
import ConfirmDel from "../components/ConfirmDel";

export default {
  name: "update_sponsors",
  data() {
      return {
        currentitem: 0,
        btn_toggle: true,
        additem_toggle: false,
        isSubmitDisabled: false,
        item: { name: "", url: "", logo: "", event_sponsor:true },
        isDelete: false,
        itemdeck: true,
        name_error: false,
        url_error: false,
      };
  },
  components: {
    UploadImage,
    ConfirmDel,
  },
  created() {},
  computed: {},
  methods: {
    getLogoName: utils.getLogoName,
    openimg: function (url) {
      console.log("url:" + url);
      if (url != "") {
        if (!url.match(/^https?:\/\//i)) {
          url = "http://" + url;
        }
        window.open(url, "_blank");
      }
    },
    new_sponsor: function () {
      this.currentitem = this.$parent.event.sponsors.length;
      this.item = { name: "", url: "", logo: "", event_sponsor:true };
      this.item.id = utils.new_id(this.$parent.event);
      console.log("item ",JSON.stringify(this.item));
      this.additem_toggle = true;
      this.btn_toggle = false;
    },
    hide_form: function () {
      this.additem_toggle = false;
      this.btn_toggle = true;
    },
    edititem: function (index) {
      this.currentitem = index;
      let sp = this.$parent.event.sponsors[this.currentitem];
      this.item = { name: "", url: "", logo: "", event_sponsor:false };
      this.item.name = sp.name;
      this.item.id = sp.id;
      this.item.event_sponsor = sp.event_sponsor || false;
      this.item.url = sp.url;
      this.item.logo = sp.logo;
      this.additem_toggle = true;
      this.btn_toggle = false;
      this.isSubmitDisabled = false;
    },
    deleteitem: function (index) {
      let del = true;
      this.$parent.event.sessions.every(session => {
       if(session.session_sponsors.includes( this.$parent.event.sponsors[index].name)){
        this.$parent.toast("err","This Sponsor has been already assigned to sessions");
        del = false;
        return false;;
       }
      });
      if(!del) return;
      this.$parent.event.sponsors[index].rem = true;
      this.itemdeck = false;
      let ev = this.$parent.event;
      window.wss_send(vx, "adm_event_set", {
        rtag: "sponsor",
        subd: window.vx.subd,
        event: {
          id: ev.id,
          sponsors: ev.sponsors
        }
      });
    },
    updateitem: function () {
      let vue = this;

      if (this.item.name == "") {
        this.name_error = true;
        return;
      } else this.name_error = false;

      if (this.item.url == "") {
        this.url_error = true;
        return;
      } else this.url_error = false;

      if (this.item.logo == "") {
        vue.$parent.toast("err","Please first upload the sponsor's logo.");
        return;
      }
      this.$parent.event.sponsors[this.currentitem] = this.item;
      this.additem_toggle = false;
      this.btn_toggle = true;
      this.itemdeck = false;
      let ev = this.$parent.event;
      window.wss_send(vx, "adm_event_set", {
        rtag: "sponsor",
        subd: window.vx.subd,
        event: {
          id: ev.id,
          sponsors: ev.sponsors
          }
      });
    },
    SetStatus: function(status){
      this.item.event_sponsor = status;
    },
    setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
    },
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.setup();
    },
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "update_sponsors");
  },
  mounted() {
    let vue = this;
    vue.setup();
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user.id,
      routes_id: "update_sponsors",
      routes: {
        adm_event_set: function (msg) {
          if (msg.rtag != "sponsor") {
            return;
          }

          if (msg.data.error) {
            console.log(msg.data.error);
            vue.isSubmitDisabled = false;
            return;
          }

          vue.additem_toggle = false;
          vue.btn_toggle = true;
          vue.itemdeck = true;
        },
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 960px;
}
.event_card {
  min-width: 15rem;
  max-width: 20rem;
  min-height: 10rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.sponsoricon {
  max-width: 8rem;
  max-height: 4rem;
  cursor: pointer;
}
</style>
